import { z } from "zod";
import { ActionCommonParamsSchema } from "../../types";

export const DouyinGetLocationParamsSchema = ActionCommonParamsSchema.extend({
    keyword: z.string().optional(),
    count: z.number().optional(),
});

export type DouyinGetLocationParams = z.infer<typeof DouyinGetLocationParamsSchema>;
